import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ModalSubmissionType,
  UPBsModalComponent,
  UPBsModalConfig,
  UPBsModalEvent,
  UPUtilityService,
} from 'up';

import { environment } from 'projects/vl/src/environments/environment';
@Component({
  selector: 'vl-interceptor-error',
  templateUrl: './interceptor-error.component.html',
  imports: [UPBsModalComponent, TranslatePipe],
})
export class InterceptorErrorComponent implements OnInit {
  bsModalConfig: UPBsModalConfig = {
    title: '',
    submitType: ModalSubmissionType.CLOSE_MODAL,
    submitBtnText: 'GENERIC.MODAL.OK_BUTTON',
    closeBtnText: '',
    hideCloseBtn: true,
    hideFooter: false,
    hideCloseIcon: true,
    featureType: '',
  };
  @Input() modalTitle!: string;
  @Input() modalBody!: string;

  constructor(
    private modalService: NgbModal,
    private upUtilityService: UPUtilityService,
  ) {}

  ngOnInit(): void {
    this.bsModalConfig.title = this.modalTitle;
    this.bsModalConfig.featureType = 'authentication-error';
  }

  handleModalEvent(event: UPBsModalEvent) {
    if (event.type === ModalSubmissionType.CLOSE_MODAL) {
      this.onExit();
    }
    this.modalService.dismissAll();
  }

  onExit() {
    this.upUtilityService.returnToCourse(`${environment.apiUrl}/vl`);
  }
}
